import { Recurrence, RecurrenceDetails } from '@tableau/self-service-schedules';
import { Request } from './Request';
import { IResult } from '../types/IResponse';
import { SelfServiceSchedule } from '../types/SelfServiceSchedule';

export type RefreshTargetType = 'Workbook' | 'Datasource' | 'Mixed';
export const ALL_REFRESH_TASK_TYPES = ['RefreshExtract', 'IncrementExtract'];
type RefreshTaskTypeTuple = typeof ALL_REFRESH_TASK_TYPES;  // Tuple of everything in ALL_REFRESH_TASK_TYPES
export type RefreshTaskType = RefreshTaskTypeTuple[number]; // Union type of everything in ALL_REFRESH_TASK_TYPES

export interface CreateExtractTasksSelfServiceSchedulesRequestParams {
    schedule: SelfServiceSchedule;
    scheduleName: string;
    targetIds: number[];
    targetType: Omit<RefreshTargetType, | 'Mixed'>;
    type: RefreshTaskType;
}

export class CreateExtractTasksSelfServiceSchedulesRequest extends Request<CreateExtractTasksSelfServiceSchedulesRequestParams, IResult> {
    constructor(params: CreateExtractTasksSelfServiceSchedulesRequestParams) {
        super('createExtractTasksSelfServiceSchedules', params);
    }
}